import axios from 'axios';

// Base URL for the API
const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5000';

/**
 * Service for vehicle management
 */
class VehiclesService {
    /**
     * Get all vehicles
     * 
     * @returns {Promise} - Promise with the vehicle data
     */
    async getVehicles() {
        return axios.get(`${API_URL}/api/vehicles`);
    }
    
    /**
     * Get a specific vehicle by ID
     * 
     * @param {String} id - The vehicle ID
     * @returns {Promise} - Promise with the vehicle data
     */
    async getVehicle(id) {
        return axios.get(`${API_URL}/api/vehicles/${id}`);
    }
    
    /**
     * Create a new vehicle
     * 
     * @param {Object} vehicleData - The vehicle data
     * @returns {Promise} - Promise with the created vehicle
     */
    async createVehicle(vehicleData) {
        return axios.post(`${API_URL}/api/vehicles`, vehicleData);
    }
    
    /**
     * Update an existing vehicle
     * 
     * @param {String} id - The vehicle ID
     * @param {Object} vehicleData - The updated vehicle data
     * @returns {Promise} - Promise with the updated vehicle
     */
    async updateVehicle(id, vehicleData) {
        return axios.put(`${API_URL}/api/vehicles/${id}`, vehicleData);
    }
    
    /**
     * Delete a vehicle
     * 
     * @param {String} id - The vehicle ID
     * @returns {Promise} - Promise with the operation result
     */
    async deleteVehicle(id) {
        return axios.delete(`${API_URL}/api/vehicles/${id}`);
    }
}

export default new VehiclesService();
